import service from '@/utils/server';

const modName='/report/dashboard/';
//查询方法
export const getDashboardData = data => {
  return service({
    url: modName+'getDashboard',
    method: 'post',
    data
  })
};
// 导出
export const exportData = data => {
  let config = {
    timeout: 500000, // 请求超时时间
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'export',
    method: 'post',
    data
  })
};



// WEBPACK FOOTER //
// ./src/page/report/dashboard/api/index.js